import { Component } from '@angular/core';
import { Routes } from '@angular/router';

import { BaMenuService } from '../theme';
import { PAGES_MENU_ADMIN } from './pages.menu';
import { PAGES_MENU_PRESIDENT } from './pages.menu';
import { PAGES_MENU_ORGANIZATOR } from './pages.menu';

@Component({
    selector: 'pages',
    template: `
        <ba-sidebar></ba-sidebar>
        <ba-page-top></ba-page-top>
            <div class="al-main">
                <div class="al-content">
                    <ba-content-top></ba-content-top>
                    <router-outlet></router-outlet>
                </div>
            </div>
        <footer class="al-footer clearfix">
      
        </footer>
        <ba-back-top position="200"></ba-back-top>
    `
})
export class Pages {

    constructor(
        private _menuService: BaMenuService
    ) { }

    ngOnInit() {
        if(localStorage.getItem('roleName') === 'administrator'){
            this._menuService.updateMenuByRoutes(<Routes>PAGES_MENU_ADMIN);
        } else if(localStorage.getItem('roleName') === 'predsjednik odbora'){
            this._menuService.updateMenuByRoutes(<Routes>PAGES_MENU_PRESIDENT);
        } else {
            this._menuService.updateMenuByRoutes(<Routes>PAGES_MENU_ORGANIZATOR);
        }
    }
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/pages/pages.component.ts